import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    badge?: ReactNode
    badgeTone?: string
    title: ReactNode
    subtitle?: ReactNode
    align?: 'center' | 'left'
    action?: ReactNode
    className?: string
}

export const Pill: FC<{ children: ReactNode, tone?: string, className?: string }> = ({ children, tone = 'bg-primary', className }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-1.5 rounded-md border-2 border-foreground px-3 py-1 text-xs font-bold shadow-brutal-sm', tone, className)}>
            {children}
        </span>
    )
}

const SectionHeading: FC<SectionHeadingProps> = ({ badge, badgeTone, title, subtitle, align = 'center', action, className }): ReactNode => {
    const centered = align === 'center'

    return (
        <div className={cn('mb-8 flex flex-col gap-3', centered ? 'items-center text-center' : 'items-start md:flex-row md:items-end md:justify-between', className)}>
            <div className={cn('flex flex-col gap-3', centered && 'items-center')}>
                {badge && <Pill tone={badgeTone}>{badge}</Pill>}

                <h2 className='text-2xl font-black leading-tight sm:text-3xl md:text-4xl'>
                    {title}
                </h2>

                {subtitle && (
                    <p className='max-w-2xl text-base leading-relaxed text-muted-foreground'>
                        {subtitle}
                    </p>
                )}
            </div>

            {action && <div className='shrink-0'>{action}</div>}
        </div>
    )
}

export default SectionHeading
